import { DiscoveryProtocol } from '../types/content';

export const discoveryProtocols: DiscoveryProtocol[] = [
  {
    id: 'a2a',
    name: 'A2A Agent Card',
    status: 'Live',
    endpoint: 'GET /.well-known/agent-card.json',
    description: 'Agents publish a self-describing card at a well-known path: who runs them, what they can do, how to authenticate, and a JWS signature so the card can be verified.',
    payloadLabel: 'agent-card.json — illustrative sample',
    payload: `{
  "protocolVersion": "0.3.0",
  "name": "Itinerary Planner",
  "description": "Plans multi-city trips and books rail segments.",
  "url": "https://agents.example-travel.com/a2a/v1",
  "preferredTransport": "JSONRPC",
  "provider": {
    "organization": "Example Travel Co.",
    "url": "https://example-travel.com"
  },
  "version": "2.4.1",
  "capabilities": { "streaming": true, "pushNotifications": false },
  "defaultInputModes": ["text/plain", "application/json"],
  "defaultOutputModes": ["application/json"],
  "skills": [
    {
      "id": "plan-trip",
      "name": "Plan trip",
      "description": "Builds a day-by-day itinerary with rail options.",
      "tags": ["travel", "rail"]
    }
  ],
  "securitySchemes": {
    "oauth2": {
      "type": "oauth2",
      "flows": {
        "clientCredentials": {
          "tokenUrl": "https://auth.example-travel.com/token",
          "scopes": { "trips.write": "Create bookings" }
        }
      }
    }
  },
  "security": [{ "oauth2": ["trips.write"] }],
  "signatures": [
    {
      "protected": "eyJhbGciOiJFUzI1NiIsImtpZCI6ImNhcmQtMjAyNiJ9",
      "signature": "MEUCIQDx…  // JWS over the canonical card"
    }
  ]
}`,
    sourceId: 'a2a',
  },
  {
    id: 'mcp',
    name: 'MCP Registry API',
    status: 'Live',
    endpoint: 'GET registry.modelcontextprotocol.io/v0/servers',
    description: 'The official registry lists MCP servers by namespaced name, with the package to install, its transport, and required arguments. Downstream directories mirror it.',
    payloadLabel: 'server.json — illustrative registry entry',
    payload: `{
  "$schema": "https://static.modelcontextprotocol.io/schemas/2025-09-29/server.schema.json",
  "name": "io.github.example/weather",
  "description": "Forecasts and severe-weather alerts.",
  "version": "1.2.0",
  "repository": {
    "url": "https://github.com/example/weather-mcp",
    "source": "github"
  },
  "packages": [
    {
      "registryType": "npm",
      "identifier": "@example/weather-mcp",
      "version": "1.2.0",
      "transport": { "type": "stdio" },
      "packageArguments": [
        { "type": "named", "name": "--units", "value": "metric" }
      ],
      "environmentVariables": [
        { "name": "WEATHER_API_KEY", "isRequired": true, "isSecret": true }
      ]
    }
  ]
}`,
    sourceId: 'mcpRegistry',
    extraSourceId: 'mcpBlog',
  },
  {
    id: 'erc8004',
    name: 'ERC-8004 on-chain identity',
    status: 'Emerging',
    endpoint: 'Identity Registry · Registered(agentId, tokenURI, owner)',
    description: 'Each agent mints an identity in an on-chain registry pointing to a registration file. Reputation and validation registries layer trust on top. Counted live on 8004scan.',
    payloadLabel: 'Decoded Registered event + registration file — illustrative',
    payload: `// event Registered(uint256 indexed agentId, string tokenURI, address indexed owner)
{
  "event": "Registered",
  "agentId": "549841",
  "owner": "0x7a3f…c91e",
  "tokenURI": "ipfs://bafybeih…/registration.json",
  "chainId": 8453,
  "blockNumber": 21894411
}

// registration.json
{
  "type": "https://eips.ethereum.org/EIPS/eip-8004#registration-v1",
  "name": "Yield Scout",
  "description": "Monitors stablecoin pools and rebalances.",
  "endpoints": [
    { "name": "A2A", "endpoint": "https://scout.example/.well-known/agent-card.json" }
  ],
  "supportedTrust": ["reputation", "validation"]
}`,
    sourceId: 'scan8004',
    extraSourceId: 'eip8004',
  },
  {
    id: 'moltbook',
    name: 'Moltbook onboarding',
    status: 'Live',
    endpoint: 'GET moltbook.com/skill.md',
    description: 'Agents read a plain-language skill file, register themselves, then wait for a human owner to verify the claim with a public post containing a one-time code.',
    payloadLabel: 'Onboarding flow — paraphrased from skill.md',
    payload: `# moltbook — agent onboarding (paraphrased)

1. Register
   POST /api/v1/agents/register
   { "name": "...", "description": "..." }

2. Response
   { "api_key": "moltbook_…", "claim_url": "…", "verification_code": "reef-4F2K" }

3. Owner claim
   Your human posts the verification_code publicly
   (a claim tweet). Moltbook links agent ↔ owner.

4. Participate
   Authorization: Bearer <api_key>
   Rate limits and anti-spam checks apply per owner.`,
    sourceId: 'moltbookSkill',
    extraSourceId: 'wikiMoltbook',
  },
];
